var _g, _path, _g2, _g3, _g4, _g5, _path2, _g6, _path3, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 278,
    viewBox: "0 0 486 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.24 138.37H5.76C3.54534 138.37 1.75 140.165 1.75 142.38V263.13C1.75 265.345 3.54534 267.14 5.76 267.14H237.24C239.455 267.14 241.25 265.345 241.25 263.13V142.38C241.25 140.165 239.455 138.37 237.24 138.37Z",
    fill: "url(#paint0_linear_346_1791)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237 136.5H6C2.68 136.5 0 139.19 0 142.5V267C0 270.32 2.68 273 6 273H237C240.31 273 243 270.32 243 267V142.5C243 139.19 240.31 136.5 237 136.5ZM241 263C241 265.21 239.21 267 237 267H6C3.79 267 2 265.21 2 263V142.5C2 140.29 3.79 138.5 6 138.5H237C239.21 138.5 241 140.29 241 142.5V263Z",
    fill: "url(#paint1_linear_346_1791)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_346_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.23 268.82H112.78C112.2 268.82 111.73 269.29 111.73 269.87V269.96C111.73 270.54 112.2 271.01 112.78 271.01H130.23C130.81 271.01 131.28 270.54 131.28 269.96V269.87C131.28 269.29 130.81 268.82 130.23 268.82Z",
    fill: "#C61F2F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.24 138.37H248.76C246.545 138.37 244.75 140.165 244.75 142.38V263.13C244.75 265.345 246.545 267.14 248.76 267.14H480.24C482.455 267.14 484.25 265.345 484.25 263.13V142.38C484.25 140.165 482.455 138.37 480.24 138.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 136.5H249C245.68 136.5 243 139.19 243 142.5V267C243 270.32 245.68 273 249 273H480C483.31 273 486 270.32 486 267V142.5C486 139.19 483.31 136.5 480 136.5ZM484 263C484 265.21 482.21 267 480 267H249C246.79 267 245 265.21 245 263V142.5C245 140.29 246.79 138.5 249 138.5H480C482.21 138.5 484 140.29 484 142.5V263Z",
    fill: "url(#paint2_linear_346_1791)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_346_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.23 268.82H355.78C355.2 268.82 354.73 269.29 354.73 269.87V269.96C354.73 270.54 355.2 271.01 355.78 271.01H373.23C373.81 271.01 374.28 270.54 374.28 269.96V269.87C374.28 269.29 373.81 268.82 373.23 268.82Z",
    fill: "#C61F2F"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.24 1.87H5.76C3.54534 1.87 1.75 3.66533 1.75 5.88V126.63C1.75 128.845 3.54534 130.64 5.76 130.64H237.24C239.455 130.64 241.25 128.845 241.25 126.63V5.88C241.25 3.66533 239.455 1.87 237.24 1.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 0H6C2.68 0 0 2.69 0 6V130.5C0 133.82 2.68 136.5 6 136.5H237C240.31 136.5 243 133.82 243 130.5V6C243 2.69 240.31 0 237 0ZM241 126.5C241 128.71 239.21 130.5 237 130.5H6C3.79 130.5 2 128.71 2 126.5V6C2 3.79 3.79 2 6 2H237C239.21 2 241 3.79 241 6V126.5Z",
    fill: "url(#paint3_linear_346_1791)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_346_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.23 132.32H112.78C112.2 132.32 111.73 132.79 111.73 133.37V133.46C111.73 134.04 112.2 134.51 112.78 134.51H130.23C130.81 134.51 131.28 134.04 131.28 133.46V133.37C131.28 132.79 130.81 132.32 130.23 132.32Z",
    fill: "#C61F2F"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.24 1.87H248.76C246.545 1.87 244.75 3.66533 244.75 5.88V126.63C244.75 128.845 246.545 130.64 248.76 130.64H480.24C482.455 130.64 484.25 128.845 484.25 126.63V5.88C484.25 3.66533 482.455 1.87 480.24 1.87Z",
    fill: "url(#paint4_linear_346_1791)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480 0H249C245.68 0 243 2.69 243 6V130.5C243 133.82 245.68 136.5 249 136.5H480C483.31 136.5 486 133.82 486 130.5V6C486 2.69 483.31 0 480 0ZM484 126.5C484 128.71 482.21 130.5 480 130.5H249C246.79 130.5 245 128.71 245 126.5V6C245 3.79 246.79 2 249 2H480C482.21 2 484 3.79 484 6V126.5Z",
    fill: "url(#paint5_linear_346_1791)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_346_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.23 132.32H355.78C355.2 132.32 354.73 132.79 354.73 133.37V133.46C354.73 134.04 355.2 134.51 355.78 134.51H373.23C373.81 134.51 374.28 134.04 374.28 133.46V133.37C374.28 132.79 373.81 132.32 373.23 132.32Z",
    fill: "#C61F2F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.77 79.45H209.24C196.515 79.45 186.2 89.7653 186.2 102.49V173.02C186.2 185.745 196.515 196.06 209.24 196.06H279.77C292.495 196.06 302.81 185.745 302.81 173.02V102.49C302.81 89.7653 292.495 79.45 279.77 79.45Z",
    fill: "url(#paint6_linear_346_1791)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.78 81.45C291.38 81.45 300.82 90.89 300.82 102.49V173.02C300.82 184.62 291.38 194.06 279.78 194.06H209.25C197.65 194.06 188.21 184.62 188.21 173.02V102.49C188.21 90.89 197.65 81.45 209.25 81.45H279.78ZM279.78 79.45H209.25C196.52 79.45 186.21 89.77 186.21 102.49V173.02C186.21 185.75 196.53 196.06 209.25 196.06H279.78C292.51 196.06 302.82 185.74 302.82 173.02V102.49C302.82 89.76 292.5 79.45 279.78 79.45Z",
    fill: "#F6F6F6"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.12 148.07L241.73 154.46C237.83 158.25 231.6 158.17 227.81 154.27C224.09 150.45 224.09 144.36 227.81 140.54L234.2 134.15C234.96 133.39 234.96 132.15 234.2 131.38C233.44 130.62 232.2 130.62 231.43 131.38L225.05 137.77C219.68 143.14 219.68 151.86 225.05 157.23C230.42 162.6 239.14 162.6 244.51 157.23L250.9 150.84C251.65 150.06 251.63 148.82 250.85 148.07C250.09 147.34 248.89 147.34 248.13 148.07H248.12Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.98 118.3C261.41 115.71 257.9 114.26 254.25 114.27C250.6 114.27 247.1 115.71 244.52 118.3L238.12 124.69C237.36 125.45 237.35 126.69 238.12 127.46C238.88 128.22 240.12 128.23 240.89 127.46L247.28 121.07C249.12 119.22 251.63 118.18 254.24 118.19C259.68 118.19 264.08 122.6 264.08 128.04C264.08 130.65 263.04 133.15 261.2 135L254.81 141.39C254.05 142.15 254.05 143.4 254.81 144.16C255.57 144.92 256.82 144.92 257.58 144.16L263.97 137.78C269.33 132.4 269.34 123.7 263.97 118.32L263.98 118.3Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 130.5L237.25 142.25C236.47 143 236.45 144.24 237.2 145.02C237.95 145.8 239.19 145.82 239.97 145.07C239.99 145.05 240 145.04 240.02 145.02L251.77 133.27C252.52 132.49 252.5 131.25 251.72 130.5C250.96 129.77 249.76 129.77 249 130.5Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_346_1791",
    x: 107.73,
    y: 266.82,
    width: 27.55,
    height: 10.1899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_1791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_1791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_346_1791",
    x: 350.73,
    y: 266.82,
    width: 27.55,
    height: 10.1899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_1791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_1791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_346_1791",
    x: 107.73,
    y: 130.32,
    width: 27.55,
    height: 10.1899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_1791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_1791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_346_1791",
    x: 350.73,
    y: 130.32,
    width: 27.55,
    height: 10.1899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_1791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_1791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_1791",
    x1: 1.75,
    y1: 202.75,
    x2: 241.25,
    y2: 202.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F071F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#200613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_1791",
    x1: 0,
    y1: 204.75,
    x2: 243,
    y2: 204.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_1791",
    x1: 243,
    y1: 0.0000144839,
    x2: 486,
    y2: 0.0000144839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_346_1791",
    x1: 0,
    y1: 68.25,
    x2: 1,
    y2: 68.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_346_1791",
    x1: 244.75,
    y1: 66.25,
    x2: 484.25,
    y2: 66.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F071F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#200613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_346_1791",
    x1: 243,
    y1: 68.25,
    x2: 486,
    y2: 68.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_346_1791",
    x1: 244.51,
    y1: 85.6,
    x2: 244.51,
    y2: 185.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding2);
export default __webpack_public_path__ + "static/media/onboarding_2.963cae2e0d85a8c49186c8dfebb9c2c1.svg";
export { ForwardRef as ReactComponent };